import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=8a9bcce6&scoped=true&"
import script from "./Remark.vue?vue&type=script&lang=js&"
export * from "./Remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9bcce6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/Remark.vue
// module id = null
// module chunks = 